// extracted by mini-css-extract-plugin
export default {"slider":"Estrenos_slider__wSubk","estreno":"Estrenos_estreno__dapuf"};